export default __webpack_public_path__ + "static/media/Anthony.584ba77a.png";